export const WalletAdminPermissions = {
  WalletAdmin: {
    permissionsId: '1725d8fa-5a2e-4099-83fb-1d82b798bf90',
    permissionsName: 'Wallet Admin',
    description: null,
    componentsId: null,
    components: null,
  },
};
